module.exports = __webpack_public_path__ + "img/fuliA.9da59a17.png";